import styled from 'styled-components';
import ErrorMessageComponent from 'components/error-message';
import { P } from 'components/typography';
import { withModifiers } from 'utils';
import { color, global } from 'styles/settings';

export const GroupLayout = styled.div`
  ${withModifiers('disabled')`
    
  `};
`;

export const OptionsLayout = styled.div`
  display: flex;
  flex-direction: ${({ display }) => display};
  margin-top: ${global.space.sm};
  margin-bottom: -${global.space.xs};
  ${withModifiers('disabled')`
    
  `};
`;

export const Label = styled(P).attrs({ secondary: true })`
  opacity: 0.3;
  ${withModifiers('$invalid')`
    color: ${color.ui.danger};
  `}
`;

export const ErrorMessage = styled(ErrorMessageComponent)`
  padding-top: 0;
  padding-bottom: 10px;
`;
